import { useFormik } from "formik";
import DatePickers from "global/DatePicker/DatePicker";
import { useFetchSampleOptions } from "global/hooks/useFetchOptions";
import InputSelect from "global/InputSelect/InputSelect";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { smsSettingValidation } from "global/Validation/Validation";
import { useState } from "react";
import { toast } from "react-toastify";
import { addEditDataAPI } from "services/CRUDServices";
import ScanWithBag from "./components/scan-with-bag";

function SMSRecipientSettings() {
  // const [bagScanModal, setBagScanModal] = useState(false);
  const [receiptBarcodes, setBarcodeLists] = useState([]);
  const {
    dataOptions: { options: smsOptions },
  } = useFetchSampleOptions(
    `/consignment-api/smsSetting/v1/s0/SmsSettingTypeSelect`
  );
  const {
    dataOptions: { options: shiftOptions },
  } = useFetchSampleOptions(`/core-api/calendar/v1/s0/shiftPeriodSelect`);

  const formik = useFormik({
    initialValues: {
      shiftPeriodId: shiftOptions?.[0],
      date: "",
      smsSettingType: smsOptions?.response?.[0],
    },
    enableReinitialize: true,
    validationSchema: smsSettingValidation,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await addEditDataAPI(
          "/consignment-api/smsSetting/v1/s0/confirmation",
          "post",
          {
            barcodeList: receiptBarcodes.map((item) => item.serialNumber),
            shiftPeriodId: values.shiftPeriodId?.id,
            smsSettingType: values.smsSettingType?.id,
            date: values.date,
          }
        );
        toast.success("عملیات با موفقیت انجام شد");
      } catch {
        setSubmitting(false);
      }
    },
  });

  const { values, errors, touched, handleSubmit, setFieldValue, isSubmitting } =
    formik;

  // async function onScan(decodedText) {
  //   try {
  //     const response = await addEditDataAPI(
  //       `/consignment-api/smsSetting/v1/s0/barcodeScan`,
  //       "post",
  //       {
  //         barcodeList: [decodedText],
  //         date: values.date,
  //       }
  //     );
  //     const data = response.data.response[0];

  //     if (data.length !== 0)
  //       setBarcodeLists([
  //         ...receiptBarcodes,
  //         { serialNumber: data.Barcode, ReceiverName: data.ReceiverName },
  //       ]);
  //   } catch (e) {}
  // }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="grid1  w-[30rem] mx-auto mt-6 border rounded-lg  p-6"
      >
        <InputSelect
          label="نوع پیامک"
          important
          name="smsSettingType"
          handleChange={setFieldValue}
          values={values.smsSettingType}
          error={touched.smsSettingType && errors.smsSettingType}
          options={smsOptions?.response}
          wrapperClassName="w-full mb-4"
          positionFixed
        />
        <DatePickers
          WrapperClassName="w-full mb-4 "
          important
          title="تاریخ "
          values={values.date}
          name="date"
          handleChange={setFieldValue}
          error={touched.date && errors.date?.day}
        />
        <InputSelect
          label="شیفت"
          important
          name="shiftPeriodId"
          handleChange={setFieldValue}
          values={values.shiftPeriodId}
          error={touched.shiftPeriodId && errors.shiftPeriodId}
          options={shiftOptions}
          wrapperClassName="w-full mb-4"
          isDisabled
        />
        <ScanWithBag
          setBarcodeLists={setBarcodeLists}
          receiptBarcodes={receiptBarcodes}
          date={values.date}
        />
        <div className="btnForm">
          <SimpleButton
            loading={isSubmitting}
            type="submit"
            text={"تایید"}
            className="full-tomato-btn"
          />
        </div>
     
      </form>

    
    </>
  );
}

export default SMSRecipientSettings;
